"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Leads = function Leads(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 43 54'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-924.000000, -361.000000)',
    fill: 'currentColor'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(100.000000, 320.000000)'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(824.000000, 41.000000)'
  }, /*#__PURE__*/_react["default"].createElement('rect', {
    x: '6.78512109',
    y: '6.75',
    width: '11.2500352',
    height: '2.24996484'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '6.78512109',
    y: '11.2500352',
    width: '2.24996484',
    height: '2.24996484'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '11.2851562',
    y: '11.2500352',
    width: '2.24996484',
    height: '2.24996484'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M42.4554961,9.32966016 L33.4555313,0.329589844 C33.2445938,0.118652344 32.958457,0 32.6601914,0 L3.41012109,0 C1.54617188,0 0.0351210938,1.51105078 0.0351210938,3.375 L0.0351210938,50.625 C0.0351210938,52.4889492 1.54617188,54 3.41012109,54 L39.4100859,54 C41.2740352,54 42.7850859,52.4889492 42.7850859,50.625 L42.7850859,10.125 C42.7850859,9.82662891 42.6665391,9.54059766 42.4554961,9.32966016 Z M40.5351211,50.625 C40.5351211,51.2463164 40.0314023,51.7500352 39.4100859,51.7500352 L3.41012109,51.7500352 C2.78880469,51.7500352 2.28508594,51.2463164 2.28508594,50.625 L2.28508594,3.375 C2.28508594,2.75368359 2.78880469,2.24996484 3.41012109,2.24996484 L32.1943359,2.24996484 L40.5351211,10.59075 L40.5351211,50.625 Z',
    fillRule: 'nonzero'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M34.9101562,8.99996484 C34.2888398,8.99996484 33.7851211,8.49624609 33.7851211,7.87492969 L33.7851211,1.12492969 L31.5351562,1.12492969 L31.5351562,7.87492969 C31.5351562,9.73887891 33.046207,11.2499297 34.9101562,11.2499297 L37.1601211,11.2499297 L37.1601211,8.99996484 L34.9101562,8.99996484 Z'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '33.7851211',
    y: '38.2500352',
    width: '2.24996484',
    height: '2.24996484'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '29.2851914',
    y: '38.2500352',
    width: '2.24996484',
    height: '2.24996484'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '6.78512109',
    y: '38.2500352',
    width: '18.0000352',
    height: '2.24996484'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '6.78512109',
    y: '43.875',
    width: '29.2499648',
    height: '2.24996484'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M33.7851211,16.875 L9.03519141,16.875 C7.79255859,16.875 6.78522656,17.882332 6.78522656,19.1249648 L6.78522656,32.6249648 C6.78522656,33.8675977 7.79255859,34.8749297 9.03519141,34.8749297 L33.7852266,34.8749297 C35.0278594,34.8749297 36.0351914,33.8675977 36.0351914,32.6249648 L36.0351914,19.1249648 C36.0351914,17.882332 35.0277539,16.875 33.7851211,16.875 Z M33.7852266,32.6249648 L9.03519141,32.6249648 L9.03519141,19.1249648 L33.7852266,19.1249648 L33.7852266,32.6249648 Z',
    fillRule: 'nonzero'
  }))))));
};
/* eslint-enable */
var _default = Leads;
exports["default"] = _default;